/** Script "Listaa" wordmark — black on light backgrounds, white on dark/glassy ones. */
export function ListaaLogo({ isLight, className = "h-8" }: { isLight: boolean; className?: string }) {
  return (
    <img
      src={isLight ? "/brand/listaa-logo-black.webp" : "/brand/listaa-logo-white.webp"}
      alt="Listaa"
      width={180}
      height={81}
      className={`w-auto ${className}`}
    />
  );
}
